import { useState, useEffect } from "react";

import './Clients.css';

import { SvgEdit, SvgReturn, SvgSetaRight } from "components/SvgFile";

import { GetDataPage, RegisterDataPage } from "interface/Data";
import { SetListPag } from "interface/Page";

export default function Page_Report_Clients(){
    const date                            = new Date();
    const [ showYear, setShowYear ]       = useState(date.getFullYear());
    const [ currentYear, setCurrentYear ] = useState(showYear);

    const [ loading, setLoading ]   = useState(false);
    const [ showData, setShowData ] = useState(GetDataPage('client'));
    const [ listData, setListData ] = useState(InitialData(currentYear));    

    const [ itensPage, setItensPage ] = useState(50);
    const [ showPage, setShowPage ]   = useState(0);

    const page         = Math.ceil(listData.length / itensPage);
    const startItens   = showPage * itensPage;
    const endItens     = startItens + itensPage;
    const currentItens = listData.slice(startItens, endItens);

    useEffect(()=>{
        RegisterDataPage('client', setShowData);
    }, []);

    useEffect(()=>{
        setListData(InitialData(currentYear));
    }, [currentYear]);

    function InitialData(value){
        const newData = showData.filter(item => item.customer_since == value);
        return newData;
    }

    function ReturnPage(){
        SetListPag('currentPage', 'report');
        SetListPag('currentPageId', 'remuve');
    }

    function OpenData(id){
        SetListPag('currentPage', 'client_details')
        SetListPag('currentPageId', id);
    }

    return(
        <div className="Page_Report_Clients">
            <div className={ loading == true ? "return_data_save div_loading" : "return_data_save" }>
                <img alt="loading" src="./assets/loading.gif" className="loading" />
            </div>
            <div className="new_block">
                <div className="div_name_page">
                    <div className="name_fixed">
                        Dashboard
                    </div>
                    <div className="show_icon">
                        <SvgSetaRight color="#CDD1D6" className="icons" />
                    </div>
                    <div className="name_fixed page_return" onClick={ ()=>{ ReturnPage() } }>
                        Relatório
                    </div>
                    <div className="show_icon" onClick={ ()=>{ ReturnPage() } }>
                        <SvgSetaRight color="#CDD1D6" className="icons" />
                    </div>
                    <div className="name_page">
                        Detalhes
                    </div>
                </div>
                <div className="">
                    <div className="name_project">
                        Clientes
                    </div>
                </div>
            </div>
            
            <div className="list_opt_year">
                <div className="div_return" onClick={ ()=>{ setCurrentYear((currentYear - 1)); } }>
                    <SvgReturn color="#324d6b" className="icons" />
                </div>
                <div className="name_project">
                    { currentYear }
                </div>
                <div className="div_return" onClick={ ()=>{ setCurrentYear((currentYear + 1)); } }>
                    <SvgReturn color="#324d6b" className="icons icon_next" />
                </div>
            </div>

            <div className="space_top">                
                <table cellPadding="0" cellSpacing="0">
                    <thead>
                        <tr>
                            <th width="20" align="center">#</th>
                            <th>Cliente</th>
                            <th width="200">Razão Social</th>
                            <th width="150">Último orçamento</th>
                            <th width="50" align="right">#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            currentItens.length > 0 ? 
                                currentItens.map((key, index)=>{
                                    return(
                                        <tr key={ index }>
                                            <td align="center">{ startItens + index + 1 }</td>
                                            <td>{ key.name }</td>
                                            <td>{ key.corporate_name ? key.corporate_name : "---" }</td>
                                            <td>{ key.last_purchase_br ? key.last_purchase_br : "---" }</td>
                                            <td align="right">
                                                <div className="list_opt">
                                                    <div onClick={ ()=>{ OpenData(key.id) } }>
                                                        <SvgEdit color="#324d6b" className="icons" />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            :
                            <tr>
                                <td colSpan="5">
                                    <div className="no_data" style={ { marginTop: 0 } }>Nenhum cliente encontrado...</div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                {
                    showData.length >= 50 ?
                    <div className="list_pages">
                        {
                            Array.from(Array(page), (item, index)=>{
                                return(
                                    <div className={ showPage == index ? "numb_page" : "numb_page page_active" } key={ index } onClick={ (e)=>{ setShowPage(index) } }>
                                        { index + 1 }
                                    </div>
                                )
                            })
                        }
                    </div> : null
                }
            </div>
        </div>
    )
}